import { run } from '@yukawa/chain-base-angular-comp/splash-screen';
import { AppModule } from 'app/app.module';
import { environment } from 'environments/environment';
import 'hammerjs';


run(AppModule, environment.production);